import {createRoot, hydrateRoot} from 'react-dom/client';
import About from '../pages/About/About'
import "../index.css";
import "../pages/About/About.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<About {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <About {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).AboutVC = {mount, hydrate, unmount}